// selectors.js

export const USER_DATA = (state) => state.user;
export const LIBRARY_DATA = (state) => state.library_data;
export const COURSE_DATA = (state) => state.selected_course;
export const LESSON_DATA = (state) => state.selected_lesson;
export const COMMUNITY_TOPIC_DATA = (state) => state.community_topics